import { appURLs } from "@/app/app-urls.mjs";
import type { GameDefinition } from "@/app/game-definition.mjs";
import { GAME_SYMBOL_ROCKETLEAGUE } from "@/game-rocket/definition-symbol.mjs";
import type { Match } from "@/game-rocket/models/match.mjs";
import type { Player } from "@/game-rocket/models/player.mjs";
import GameIconBoxRocketL from "@/inline-assets/game-icon-box-rocketleague.svg";
import GameIconShapeRocketL from "@/inline-assets/game-icon-shape-rocketleague.svg";

export { GAME_SYMBOL_ROCKETLEAGUE };

const definition = {
  gameSymbol: GAME_SYMBOL_ROCKETLEAGUE,
  friendlyName: ["common:games.rocketleague.short", "Rocket League"],
  fullName: ["common:games.rocketleague.long", "Rocket League"],
  shortName: "rocketleague" as const,
  gameColor: "#538BFB",

  iconShape: GameIconShapeRocketL,
  iconBox: GameIconBoxRocketL,
  icon: "",
  imageKeyart: `${appURLs.CDN}/blitz/ui/img/game-cover/rocketleague-min.webp`,

  isActive: "comingSoon",
  preferFriendlyName: false as const,
  IPC: () => import("@/game-rocket/init.mjs"),

  /**
   * Any developer that inherits or works on Rocket League do not modify
   * the settings, navLinks, routes, isActive -- until you need to release.
   * This definitions file is being referenced and this is not a dummy file.
   *
   * Lets not do mega PRs please
   * Try to create smaller PR work as they are completed to avoid release
   * delays and stressed out code reviewers, thanks!
   */
  settings: () => Promise.resolve({ default: () => null }),
  navLinks: [],
  routes: [],
} satisfies GameDefinition<typeof GAME_SYMBOL_ROCKETLEAGUE>;

export default definition;

declare module "@/__main__/app-state.mjs" {
  interface AppState {
    rocket: {
      profiles: Record<string, Player>;
      matches: Record<string, Match>;
      liveGame: null;
    };
  }
}
